export default {
	rules: {
		required: "Angabe erforderlich",
		requiredTrailingSpace: "Angabe erforderlich. ",
		onlyWhitespace: "Eingabe darf nicht nur Leerzeichen sein.",
		maxLength35: "Maximal 35 Zeichen erlaubt.",
		maxLength50: "Maximal 50 Zeichen erlaubt.",
		maxLength50TrailingSpace: "Maximal 50 Zeichen erlaubt. ",
		invalidCharacters: 'Enthält unerlaubte Zeichen "* ^  { } [ ] = < > |"',
		invalidEmail: "Muss eine gültige E-Mail Adresse sein. ",
		notANumber: "Muss eine Zahl sein.",
		mustBePositive: "Muss positiv sein.",
		noDecimals: "Keine Kommastellen erlaubt",
		notAnInteger: "Muss eine ganze Zahl sein.",
		outOfRange0To1000: "Muss zwischen 0 und 1000 sein",
	},
	messages: {
		allUsers: "Allen Benutzern",
		savedCartQuantitySet:
			"Die Anzahl für Artikel {articleId} wurde in der Stückliste auf {quantity} Stk. festgelegt.",
		savedCartQuantityError: "Stückzahl konnte nicht angepasst werden.",
		savedCartRemoveArticleError: "Artikel konnte nicht aus Stückliste entfernt werden.",
		savedCartAddArticleError: "Artikel konnte nicht der Stückliste hinzugefügt werden.",
		addressDeleted: "Adresse wurde gelöscht.",
		addressDeleteError: "Adresse konnte nicht gelöscht werden.",
		addressSetPreferred: "Adresse wurde als Favorit markiert.",
		addressSetPreferredError: "Adresse konnte nicht als Favorit markiert werden.",
		weldlineOne: "1 Schweißnaht",
		weldlineMultiple: "{count} Schweißnähte",
		cornerOne: "1 Ecke",
		cornerMultiple: "{count} Ecken",
		cleaned: "verputzt",
		notCleaned: "unverputzt",
		powderFinishMatt: "Matt",
		powderFinishGlossy: "Glanz",
		notAvailable: "Nicht verfügbar",
		powderStructureSmooth: "Glatt",
		powderStructureFine: "Fein",
		powderStructureRough: "Grob",
	},
};
